// removed by extract-text-webpack-plugin
module.exports = {"flipperСontainer":"flipper__flipperСontainer--8uaHA","flipper":"flipper__flipper--19q0q","front":"flipper__front--3yq-n","back":"flipper__back--2M5uH","image":"flipper__image--3K2v1","dots":"flipper__dots--3lK6X","togglersContainer":"flipper__togglersContainer--1H14Y","toggler":"flipper__toggler--3qN76","togglerLeft":"flipper__togglerLeft--3bJT9 flipper__toggler--3qN76","togglerRight":"flipper__togglerRight--3J7Bw flipper__toggler--3qN76","sensor":"flipper__sensor---uM55","togglersPlaceholder":"flipper__togglersPlaceholder--1S_q3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/FlipperSection/flipper.css
// module id = +Bhx
// module chunks = 0